import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import messages from '@/modules/tasks/taskMessages';
import { useGetAssignmentTemplates } from '@/shared/hooks/task/useGetAssignmentTemplates';
import guid from '@/shared/utils/guid';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import { hasAssignments } from '../../security/HasAssignments';
import AutoComplete from '../select/AutoComplete';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
export const AssignmentTemplateSelector = ({ initialValue, placeholder, onChange, }) => {
    const { formatMessage } = useIntl();
    const { data } = useGetAssignmentTemplates();
    const assignmentTemplates = useMemo(() => data === null || data === void 0 ? void 0 : data.map(item => ({
        key: item.id,
        code: item.code || '',
        label: `${item.code ? `${item.code} – ` : ''}${formatMessage(listItemMsg('assignmenttemplate', item.id, item.name))}`,
    })).sort(dynamicSortMultiple('code', 'label')), [data, formatMessage]);
    const items = useMemo(() => {
        var _a;
        return (_a = (assignmentTemplates && [
            { key: guid.empty, label: formatMessage(messages.DefaultAssignment) },
            ...assignmentTemplates,
        ])) !== null && _a !== void 0 ? _a : undefined;
    }, [assignmentTemplates, formatMessage]);
    const initialSelectedItem = useMemo(() => { var _a; return (_a = (initialValue && (items === null || items === void 0 ? void 0 : items.find(item => (item === null || item === void 0 ? void 0 : item.key) === initialValue)))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, items]);
    return (_jsx(AutoComplete, { items: items, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(item === null || item === void 0 ? void 0 : item.key) }));
};
export const FilterAssignmentTemplateSelector = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => ({
    filterItem: item,
    enabled: enabled,
    filterSelectLabel: !isAlwaysVisible ? label : undefined,
    element: hasAssignments() ? (_jsx(AssignmentTemplateSelector, { initialValue: activeFilters[item], onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), placeholder: label })) : null,
});
